// extracted by mini-css-extract-plugin
export default {"container":"xk-z","blurb":"yk-z","links":"zk-z"};